const DistanceUnit = {
	MILES: "miles",
	KILOMETERS: "kilometers",
	NAUTICAL_MILES: "nauticalMiles"
};
export default DistanceUnit;
